import { i18n } from "@lingui/core";
import { msg, selectOrdinal } from "@lingui/core/macro";

import { PatientScheduleResponse } from "../../api";
import { dayNames } from "../../utils/data-utils";

/** Human-readable summary of a schedule's frequency and times. */
export function scheduleToString(member: PatientScheduleResponse) {
  const repeatEvery = member.schedule_frequency_regular_repeat_every;
  const freqString =
    repeatEvery != null
      ? everyNthDay(repeatEvery)
      : i18n._(msg`Days: ${schedDays(member)}`);
  const times = member.schedule_times.map(formatTimeDisplay).join(", ");
  return i18n._(msg`${freqString} at times: ${times}`);
}

/**
 * "Every 3rd day", in the active locale. One `selectOrdinal` so each locale
 * supplies its own ordinal form — a hardcoded English suffix would otherwise
 * read as "Každý 3rd deň". Shared with the medications table, which shows the
 * same phrase.
 */
export function everyNthDay(repeatEvery: number) {
  return i18n._(
    msg`Every ${selectOrdinal(repeatEvery, {
      one: "#st",
      two: "#nd",
      few: "#rd",
      other: "#th",
    })} day`,
  );
}

function schedDays(member: PatientScheduleResponse) {
  return (member.schedule_frequency_on_days ?? [])
    .map((day) => i18n._(dayNames[day]))
    .join("/");
}

/** Format time for display (strip seconds if present) */
export function formatTimeDisplay(time: string): string {
  const parts = time.split(":");
  return `${parts[0]}:${parts[1]}`;
}
